import { useEffect, useState } from 'react'
import '../../assets/styles/customFilter.css'
import useDebounce from '../../hooks/useDebounce'

const CustomStringFilter = ({ colDef, setApiParams }) => {
  const { id } = colDef
  const [selectedFilter, setSelectedFilter] = useState("")
  const [stringFilterVal, setStringFilterVal] = useState('')
  const debouncedSearchBoxValue = useDebounce(stringFilterVal)

  useEffect(() => {
    if (selectedFilter === "") {
      setStringFilterVal('')
    }
  }, [selectedFilter])

  useEffect(() => {
    setApiParams(oldParams => {
      try {
        if (selectedFilter && debouncedSearchBoxValue) {
          const newFilterColDef = {
            colId: id,
            filterType: selectedFilter,
            dataType: 'string',
            stringFilterVal: debouncedSearchBoxValue
          }
          return {
            ...oldParams,
            filterCols: oldParams.filterCols.find(filter => filter.colId === id) ?
              [...oldParams.filterCols.filter(filter => filter.colId !== id), newFilterColDef] :
              [...oldParams.filterCols, newFilterColDef]
          }
        }
        else {
          return {
            ...oldParams,
            filterCols: [...oldParams.filterCols.filter(filter => filter.colId !== id)]
          }
        }
      } catch (error) {
        console.log(error)
        return { ...oldParams }
      }
    })
  }, [selectedFilter, debouncedSearchBoxValue])

  return (
    <div className="customFilter">
      <div className="customSelect">
        <select
          value={selectedFilter}
          onChange={e => setSelectedFilter(e.target.value)}
        >
          <option value="">Select Filter</option>
          <option value="contains">Contains</option>
          <option value="doesNotContain">Does Not Contain</option>
          <option value="equals">Equals</option>
          <option value="doesNotEqual">Does Not Equal</option>
          <option value="beginsWith">Begins With</option>
          <option value="endsWith">Ends With</option>
        </select>
      </div>

      {selectedFilter !== '' &&
        <div className="inputsDiv">
          <input
            type="text"
            value={stringFilterVal}
            disabled={selectedFilter === ''}
            placeholder={'Enter Text'}
            onChange={e => setStringFilterVal(e.target.value)}
          />
        </div>
      }
    </div>
  )
}

export default CustomStringFilter
